import { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  arrayRemove,
  arrayUnion,
  getDocs,
  collection,
    onSnapshot
} from "firebase/firestore";

import { uploadToCloudinary } from "../../utils/cloudinary";
import { useModal } from "../../ModalContext";
import GroupAvatar from "../ui/GroupAvatar";

export default function GroupModal({ group, onClose }) {
  const user = localStorage.getItem("user");
  const { setUserModal } = useModal();

  const [data, setData] = useState(null);
  const [membersData, setMembersData] = useState([]);
  const [allUsers, setAllUsers] = useState([]);

  const [editName, setEditName] = useState("");
  const [editDesc, setEditDesc] = useState("");

  const [search, setSearch] = useState("");
  const [showAdd, setShowAdd] = useState(false);

  const removeAvatar = async () => {
  await updateDoc(doc(db, "chats", group.id), {
    avatar: ""
  });
};

  // 🔥 загрузка
  useEffect(() => {
  if (!group?.id) return;

  // 🔥 подписка на чат (главное!)
  const unsubChat = onSnapshot(doc(db, "chats", group.id), async (snap) => {
    if (!snap.exists()) return;

    const d = snap.data();

    setData(d);
    setEditName(d.name || "");
    setEditDesc(d.description || "");

    // 🔥 обновляем участников В РЕАЛЬНОМ ВРЕМЕНИ
    const users = await Promise.all(
      (d.members || []).map(async (u) => {
        const us = await getDoc(doc(db, "users", u));
        return {
          username: u,
          ...(us.exists() ? us.data() : {})
        };
      })
    );

    setMembersData(users);
  });

  // 🔥 загружаем всех пользователей (один раз достаточно)
  const loadUsers = async () => {
  const me = await getDoc(doc(db, "users", user));
  if (!me.exists()) return;

  const friends = me.data().contacts || [];

  const users = await Promise.all(
    friends.map(async (f) => {
      const snap = await getDoc(doc(db, "users", f));
      return {
        username: f,
        ...(snap.exists() ? snap.data() : {})
      };
    })
  );

  setAllUsers(users);
};

  loadUsers();
  

  return () => unsubChat();
}, [group.id]);

  if (!data) return null;
const members = data.members || [];

  const isAdmin = data.admin === user;

  // 💾 сохранить + закрыть
  const save = async () => {
    await updateDoc(doc(db, "chats", group.id), {
      name: editName,
      description: editDesc,
    });

    onClose();
  };

  const changeAvatar = async (file) => {
  if (!file) return;

  const url = await uploadToCloudinary(file);

  console.log("UPLOAD URL:", url); // 👈 СМОТРИ СЮДА

  if (!url) return;

  await updateDoc(doc(db, "chats", group.id), {
    avatar: url
  });
};

  const addUser = async (username) => {
    await updateDoc(doc(db, "chats", group.id), {
      members: arrayUnion(username)
    });
  };

  const removeUser = async (username) => {
    await updateDoc(doc(db, "chats", group.id), {
      members: arrayRemove(username)
    });
  };

  const deleteGroup = async () => {
  const chatRef = doc(db, "chats", group.id);

  const snap = await getDoc(chatRef);
  if (!snap.exists()) return;

  const data = snap.data();
  const members = data.members || [];

  // 🔥 удалить чат у всех пользователей
  await Promise.all(
    members.map(async (u) => {
      await updateDoc(doc(db, "users", u), {
        groups: arrayRemove(group.id)
      });
    })
  );

  // 🔥 удалить ВСЕ сообщения
  const msgs = await getDocs(collection(db, "chats", group.id, "messages"));

  await Promise.all(
    msgs.docs.map((m) =>
      deleteDoc(doc(db, "chats", group.id, "messages", m.id))
    )
  );

  // 🔥 удалить сам чат
  await deleteDoc(chatRef);

  onClose();
};


  const leaveGroup = async () => {
  // удалить из чата
  await updateDoc(doc(db, "chats", group.id), {
    members: arrayRemove(user)
  });

  // 🔥 удалить из пользователя
  await updateDoc(doc(db, "users", user), {
    groups: arrayRemove(group.id)
  });

  onClose();
};

  const filteredUsers = allUsers.filter(u =>
  u.username.toLowerCase().includes(search.toLowerCase()) &&
  !(data.members || []).includes(u.username)
);

const isOnline = (user) => {
  return Date.now() - (user.lastSeen || 0) < 15000;
};

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>

        {/* HEADER */}
        <div style={styles.header}>
          <div>Группа • {(data.members || []).length}</div>
          <div style={styles.close} onClick={onClose}>✕</div>
        </div>

        {/* AVATAR */}
        {/* AVATAR */}
<div style={styles.avatarBlock}>
  <GroupAvatar
    src={data.avatar}
    name={data.name || membersData.map(m => m.name || m.username).join(", ")}
    size={80}
  />


          {isAdmin && (
            <label style={styles.uploadBtn}>
              Изменить
              <input
                type="file"
                hidden
                onChange={(e) => changeAvatar(e.target.files[0])}
              />
            </label>
          )}
        </div>

        {/* NAME */}
        {isAdmin ? (
          <input
            value={editName}
            onChange={(e) => setEditName(e.target.value)}
            style={styles.input}
          />
        ) : (
          <div style={styles.title}>{data.name}</div>
        )}

        {/* DESC */}
        {isAdmin ? (
          <textarea
            value={editDesc}
            onChange={(e) => setEditDesc(e.target.value)}
            style={styles.textarea}
          />
        ) : (
          <div style={styles.desc}>
            {data.description || "Без описания"}
          </div>
        )}

        {/* MEMBERS */}
<div style={styles.members}>
  {membersData.map((m, i) => (
    <div
      key={m.username}
      style={styles.member}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.06)";
        e.currentTarget.style.transform = "translateX(6px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.03)";
        e.currentTarget.style.transform = "translateX(0px)";
      }}
    >
      <div style={{ position: "relative" }}>
  <img
    src={m.avatar || "https://via.placeholder.com/40"}
    style={styles.memberAvatar}
    onClick={() => setUserModal({ username: m.username, ...m })}
  />

  {isOnline(m) && (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        right: 0,
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: "#4cff4c",
        boxShadow: "0 0 6px #4cff4c",
        border: "2px solid #111",
      }}
    />
  )}
</div>

      <div style={{ flex: 1 }}>
        <div style={styles.nameRow}>
          {m.name || m.username}
          {m.username === data.admin && (
            <span style={styles.admin}>админ</span>
          )}
        </div>

        <div style={styles.status}>
            {m.status || "без статуса"}
        </div>
      </div>

      {isAdmin && m.username !== user && (
        <button
          onClick={() => removeUser(m.username)}
          style={styles.iconBtn}
        >
          ✕
        </button>
      )}
    </div>
  ))}
        </div>

        {/* ADD USERS */}
        {isAdmin && (
          <>
            <button style={styles.btn} onClick={() => setShowAdd(!showAdd)}>
              Добавить участника
            </button>

            {showAdd && (
              <>
                <input
                  placeholder="Поиск..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={styles.input}
                />

                <div style={styles.members}>
                  {filteredUsers.slice(0, 8).map(u => (
                    <div key={u.username} style={styles.member}>
                      <img
                        src={u.avatar || "https://via.placeholder.com/40"}
                        style={styles.memberAvatar}
                      />

                      <div style={{ flex: 1 }}>
                        <div>{u.name || u.username}</div>
                        <div style={styles.status}>
                          {u.bio || "без статуса"}
                        </div>
                      </div>

                      <button
                        style={styles.iconBtn}
                        onClick={() => addUser(u.username)}
                      >
                        +
                      </button>
                    </div>
                  ))}
                </div>
              </>
            )}
          </>
        )}

        {/* ACTIONS */}
        <div style={styles.actions}>
          {isAdmin ? (
            <>
              <button style={styles.btn} onClick={save}>
                Сохранить
              </button>

              <button style={styles.btnDanger} onClick={deleteGroup}>
                Удалить
              </button>
            </>
          ) : (
            <button style={styles.btn} onClick={leaveGroup}>
              Выйти
            </button>
          )}
        </div>

      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.6)",
    backdropFilter: "blur(12px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999
  },

  modal: {
    width: 360,
    maxHeight: "90vh",
    overflowY: "auto",
    padding: 20,
    borderRadius: 20,
    background: "rgba(20,20,20,0.9)",
    border: "1px solid rgba(255,255,255,0.1)",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    animation: "pop 0.25s ease"
  },

  header: { display: "flex", justifyContent: "space-between", opacity: 0.8 },
  close: { cursor: "pointer" },

  avatarBlock: { display: "flex", flexDirection: "column", alignItems: "center", gap: 6 },
  avatar: { width: 80, height: 80, borderRadius: "50%" },

  uploadBtn: {
    padding: "6px 12px",
    borderRadius: 10,
    background: "rgba(255,255,255,0.08)",
    cursor: "pointer",
    fontSize: 12
  },

  title: { textAlign: "center", fontWeight: 600 },
  desc: { textAlign: "center", opacity: 0.7 },

  input: {
    padding: 10,
    borderRadius: 10,
    background: "rgba(255,255,255,0.05)",
    color: "#fff",
    border: "1px solid rgba(255,255,255,0.1)"
  },

  textarea: {
    padding: 10,
    borderRadius: 10,
    background: "rgba(255,255,255,0.05)",
    color: "#fff"
  },

  members: { 
  display: "flex", 
  flexDirection: "column",
  gap: 10,
  width: "100%" // 🔥 иногда нужно
},

member: { 
  display: "flex", 
  alignItems: "center", 
  gap: 12,
  padding: "10px 12px",   // 🔥 больше воздуха
  borderRadius: 14,

  background: "rgba(255,255,255,0.03)",
  transition: "all 0.2s ease",
},

  memberAvatar: { width: 36, height: 36, borderRadius: "50%" },

  nameRow: { display: "flex", gap: 6 },
  admin: { fontSize: 10, opacity: 0.6 },
  status: { fontSize: 11, opacity: 0.6 },

  divider: { height: 1, background: "rgba(255,255,255,0.05)" },

  iconBtn: {
    background: "rgba(255,255,255,0.08)",
    border: "none",
    borderRadius: 8,
    padding: "4px 8px",
    color: "#fff"
  },

  actions: { display: "flex", gap: 8 },

  btn: {
    flex: 1,
    padding: 10,
    borderRadius: 10,
    background: "rgba(255,255,255,0.1)",
    color: "#fff",
    border: "none"
  },

  btnDanger: {
    flex: 1,
    padding: 10,
    borderRadius: 10,
    background: "rgba(255,80,80,0.8)",
    color: "#fff",
    border: "none"
  }
};